module.exports = __webpack_public_path__ + "static/img/btn-bg-colorful.37c86bb5.png";